import React from "react";
import { Button } from "semantic-ui-react";

const CloseButton = (props) => {
  const onClick = (e) => {
    e.stopPropagation();
    props.onClose();
  };

  return (
    <Button
      icon="window close"
      floated="right"
      className="close"
      onClick={onClick}
    />
  );
};

export default CloseButton;
